<template>
  <div class="bg-card-grey">
    <div class="cardy-body-noBorder">
      <h4 class="color-dar-purple mb-3">APLICAÇÕES</h4>
      <div
        v-for="apply in applies"
        :key="apply.id"
      >
        <p class="m-0">

          <font-awesome-icon
            icon="times-circle"
            class="text-danger pointer mr-3"
            @click="removeApply(apply.id)"
          />
          <strong class="color-dark-purple">
            {{ apply.title }}
          </strong>
        </p>
        <span class="f11">{{ new Date(apply.created_at) | date }}</span>
        <hr />
      </div>
      <button
        style="width: 100%"
        class="color-white btn-add-items-tb bg-purple"
        @click="openForm()"
      >
        Adicionar à vaga
      </button>
    </div>
  </div>
</template>

<script>
import CopyCandidates from "components/CopyCandidates.vue";

export default {
  props: ["talent_banks_id", "candidates"],
  data: () => ({
    applies: [],
  }),
  mounted() {
    this.populate();
  },
  methods: {
    removeApply(id) {
      let conf = confirm("tem certeza que deseja deletar essa aplicação?");
      if (!conf) return;
      axios.delete("/recruiters/applies/" + id).then((response) => {
        console.log(response);
        this.populate();
      });
    },
    populate() {
      axios
        .get(
          "/recruiters/talent_banks/" +
            this.talent_banks_id +
            "/candidate/applies"
        )
        .then((response) => {
          console.log(response.data);
          this.applies = response.data;
        });
    },
    openForm() {
      this.$modal.show(
        CopyCandidates,
        {
          candidates: this.candidates,
        },
        {
          width: "60%",
          height: "auto",
          scrollable: false,
        },
        {
          "before-close": (event) => {
            eventBus.$emit("resetSelected");
          },
        }
      );
    }
  },
};
</script>

<style>
</style>